var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center"}},[_c('loading-progress',{attrs:{"indeterminate":"","fill-duration":"2","shape":"line"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }